import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, useForm } from "react-hook-form";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useQyCreateBilling } from "@factory/query/billing.query";
import { BillingFormRule, BillingFormSchema } from "@factory/form/form.rule";
import { billingFormDefault } from "@factory/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export function useNewBilling() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateBilling } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Billing is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addBilling, isLoading: isCreating } =
    useQyCreateBilling(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<BillingFormSchema>({
    defaultValues: billingFormDefault,
    resolver: zodResolver(BillingFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: BillingFormSchema) => {
    const formData = mapCreateBilling(form);
    addBilling(formData);
  };
  const handleValidateError = (err: FieldErrors<BillingFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
